import cx from "@hsl/core/utils/cx";

import { Translate } from "../../../hooks/useTranslation";

interface Props {
    showSelectedDocuments?: boolean;
    children: React.ReactNode;
}

export const Table = ({ showSelectedDocuments, children }: Props) => {
    return (
        <table className="mt-4 w-full table-auto">
            <thead className="max-md:hidden">
                <tr className="bg-platinum [&>th]:w-max [&>th]:px-5 [&>th]:py-2.5 [&>th]:font-medium">
                    <th>
                        <Translate>Fund</Translate>
                    </th>
                    <th>
                        <Translate>Shared by</Translate>
                    </th>
                    <th>
                        <div
                            className={cx(
                                !showSelectedDocuments && "invisible",
                            )}
                        >
                            <Translate>Selected documents</Translate>
                        </div>
                    </th>
                    <th />
                    <th />
                </tr>
            </thead>
            <tbody>{children}</tbody>
        </table>
    );
};
